
// Our modal code needs access to the root element (as well as index.tsx), so putting this in a central place
export const rootElementId = 'app-root';
export const rootElementSelector = `#${rootElementId}`
export const getRootElement = () => document.getElementById(rootElementId);
